import { inject, Injectable } from '@angular/core';
import { ENotificationRefCat, INotificationReceiver } from '../../../Reusables/reusable-pages/messages/messages.model';
import { UtilityService } from '../../../Services/utility.service';
import { IObjectLiteral } from 'ets-fe-ng-sdk';
import { ViewDocumentModalComponent } from '../../../Reusables/reusable-comps/view-document-modal/view-document-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationHandlerService {

  readonly uS = inject(UtilityService);

  serviceHandleNotificationOpen(notification: INotificationReceiver) {
    console.log(notification);
    const refCat = notification._notification?.refCat,
      refNo = notification._notification?.refNo;
    switch (refCat) {
      case ENotificationRefCat.workflow:
        this.go('workflow-desk/view/index', { wfNo: refNo });
        return true;
      case ENotificationRefCat.quote:
        this.go('policy-desk/view-proposal', { quoteNo: refNo, screen: 'POL' });
        return true;
      case ENotificationRefCat.claim:
        this.go('payment-desk/view-claim', { claimNo: refNo });
        return true;
      case ENotificationRefCat.batch:
        this.go('admin-desk/batch/activities', { requestId: refNo });
        return true;
      default:
        return false;
    }
  }

  openDocument(notification: INotificationReceiver) {
    this.uS.dialogOpener(
      ViewDocumentModalComponent,
      {
        width: '80%',
        maxWidth: '90%',
        maxHeight: '90vh',
        data: {
          notification,
        },
      },
      () => {},
    );
    return true;
  }
  handleNotificationOpen(notification: INotificationReceiver) { 
    if (notification._notification.refCat === 'DOC') return this.openDocument(notification);
    else return this.serviceHandleNotificationOpen(notification);
  }
  protected go(route: string, queryParams: IObjectLiteral) {
    return this.uS.absoluteRouting(route, { queryParams, useRedirect: true });
  }
}
